export default __webpack_public_path__ + "static/media/down.cb813fe5.svg";